module.exports = __webpack_public_path__ + "static/media/menu.5ab8555b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu.svg
// module id = 1114
// module chunks = 2